import { MenuTabType } from '@/types';
import { NavLink, useLocation } from 'react-router-dom';
import { FC } from 'react';

import styles from './Header.module.scss';
import { Typography } from 'antd';

interface HeaderNavigationProps {
  tabItems: MenuTabType[];
}

const HeaderNavigation: FC<HeaderNavigationProps> = ({ tabItems }) => {
  const location = useLocation();

  return (
    <div className={styles.headerTabMenu}>
      {tabItems.map((tab) => (
        <div key={tab.key} className={styles.tabItem}>
          <NavLink
            to={tab.link}
            className={({ isActive }) =>
              isActive ? styles.activeTab : styles.inactiveTab
            }
          >
            <Typography.Text className={styles.tabText}>
              {tab.label}
            </Typography.Text>
          </NavLink>
        </div>
      ))}
    </div>
  );
};

export default HeaderNavigation;
